module.exports = __webpack_public_path__ + "assets/img/dgoods-step4-active-green.58f6418f.svg";